__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-06-1786018551-stable-dev/";